export default __webpack_public_path__ + "assets/images/topHatComp-5919d1fcf7fc19f8086f3703ca81027b.png";